module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAH5QTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgraD7AAAACp0Uk5TT7tKAMEJCr2pLMCwYayqp+rmqySlpnc4teFCBtm516i2DVzT1q6xrU5mr4q7MAAAAI5JREFUeJydkM0SgjAMhIMrGIsiVgH/EBQEff8X1DYcSmU8uIedzje7SVuiIJjBE83DaPEFGeClchWvLPSCawMTbCSTGttCC9QSSYzpn3CYujPGXhJTdUzV96M6y5UyIFfp3zNRHI7OTGEnfWYLL2V5RSWwvuH+OTM1YdQik+2P3H4IUze8zlFPz0p5il9vWOQMNcuhiJ0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/u1.png
// module id = gjia
// module chunks = 1